<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <clever-ferienhauserziel [mode]="'home'" class="w270p"></clever-ferienhauserziel>
            <clever-date [start]="ferienFiltersService.start" [end]="ferienFiltersService.end"
                (selectValue)="selectDateValue($event)" [mode]="'home'" class="w300px"></clever-date>
            <clever-selectionlist [beliebig]="false" [icon]="'timelapse'"
                [currentItem]="(myferienfilters?.dauer === '1' ? myferienfilters?.dauer + ' Nacht' : myferienfilters?.dauer === '-1' ? myferienfilters?.dauer : myferienfilters?.dauer + ' Nächte')"
                (triggerChange)="selectDauer($event)" [title]="'Dauer '" [list]="dauers" [mode]="'home'">
            </clever-selectionlist>
            <clever-ferienhauserreisende [mode]="'home'"></clever-ferienhauserreisende>
            <button matTooltip="Mehr Filter" aria-label="Mehr Filter" (click)="openclosemore()" matRipple>
                <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext}}</span>
            </button>
        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">
        <div class="tmp-extrafilter-wraper-mobile w100">
            <clever-ferienhauserziel [mode]="'home'" class="w100"></clever-ferienhauserziel>
            <clever-date [start]="ferienFiltersService.start" [end]="ferienFiltersService.end"
                (selectValue)="selectDateValue($event)" [mode]="'nohome'" class="w100">
            </clever-date>
            <div class="gr-btn-mobile w100">
                <clever-selectionlist class="w50" [beliebig]="false" [icon]="'timelapse'"
                    [currentItem]="(myferienfilters?.dauer === '1' ? myferienfilters?.dauer + ' Nacht' : myferienfilters?.dauer === '-1' ? myferienfilters?.dauer : myferienfilters?.dauer + ' Nächte')"
                    (triggerChange)="selectDauer($event)" [title]="'Dauer '" [list]="dauers" [mode]="'home'">
                </clever-selectionlist>
                <clever-ferienhauserreisende class="w50" [mode]="'home'"></clever-ferienhauserreisende>
            </div>
            <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
            <button matTooltip="Mehr Filter" aria-label="Mehr Filter" class="tmp-mehrfilter-mobile"
                (click)="openclosemore()" matRipple>
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext}}</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #nohomemodeMobile>
    <ng-container *ngIf="smallVersion else mbfilter">
        <div class="tmp-inputs-wrapper-nohome-mobile">
            <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
                <div class="m05">
                    <span class="smallfilter-title">
                        Ferienhäuser {{myferienfilters?.reisezielResult?.title?.length > 0 ?
                        myferienfilters?.reisezielResult?.title : 'Beliebig'}}
                    </span>
                    <div class="smallfilter-body">
                        <span class="smallitem">
                            {{(myferienfilters?.dauer === '1' ? myferienfilters?.dauer + ' Nacht' :
                            myferienfilters?.dauer === '-1' ? myferienfilters?.dauer : myferienfilters?.dauer + '
                            Nächte')}} |
                        </span>
                        <span class="smallitem">
                            {{prsText}}
                        </span>
                    </div>
                </div>
                <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                    <mat-icon fontIcon="search"></mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #mbfilter>
    <div class="smallfilterbig-mobile-wrapper">
        <clever-ferienhauserziel [mode]="'home'" class="w100"></clever-ferienhauserziel>
        <clever-date [start]="ferienFiltersService.start" [end]="ferienFiltersService.end"
            (selectValue)="selectDateValue($event)" [mode]="'nohome'" class="w100">
        </clever-date>
        <div class="gr-btn-mobile w100">
            <clever-selectionlist class="w50" [beliebig]="false" [icon]="'timelapse'"
                [currentItem]="(myferienfilters?.dauer === '1' ? myferienfilters?.dauer + ' Nacht' : myferienfilters?.dauer === '-1' ? myferienfilters?.dauer : myferienfilters?.dauer + ' Nächte')"
                (triggerChange)="selectDauer($event)" [title]="'Dauer '" [list]="dauers" [mode]="'home'">
            </clever-selectionlist>
            <clever-ferienhauserreisende class="w50"></clever-ferienhauserreisende>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext}}</span>
        </button>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <clever-ferienhauserziel [mode]="'nohome'" class="w100"></clever-ferienhauserziel>
        <clever-date [start]="ferienFiltersService.start" [end]="ferienFiltersService.end"
            (selectValue)="selectDateValue($event)" [mode]="'nohome'" class="w100">
        </clever-date>
        <div class="gr-btn-mobile w100">
            <clever-selectionlist class="w50" [beliebig]="false" [icon]="'timelapse'"
                [currentItem]="(myferienfilters?.dauer === '1' ? myferienfilters?.dauer + ' Nacht' : myferienfilters?.dauer === '-1' ? myferienfilters?.dauer : myferienfilters?.dauer + ' Nächte')"
                (triggerChange)="selectDauer($event)" [title]="'Dauer '" [list]="dauers" [mode]="'nohome'">
            </clever-selectionlist>
            <clever-ferienhauserreisende class="w50"></clever-ferienhauserreisende>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext}}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilter>
    <clever-ferienhauserextrafilters [mode]="'home'" class="w100 max1000" (closeModal)="openclosemore()">
    </clever-ferienhauserextrafilters>
</ng-template>